import { render, staticRenderFns } from "./SessionBlockScoreChart.vue?vue&type=template&id=6e96b74d&scoped=true&"
import script from "./SessionBlockScoreChart.vue?vue&type=script&lang=js&"
export * from "./SessionBlockScoreChart.vue?vue&type=script&lang=js&"
import style0 from "./SessionBlockScoreChart.vue?vue&type=style&index=0&id=6e96b74d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e96b74d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
